export enum QuoteTimePeriod {
  MINUTE = 'MINUTE',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH'
}

